/**
 * A list of Vue components that are embedded directly into Angular templates.
 *
 * @see EposAppRoot.vue setActiveEmbeddedComponents()
 */
const EmbeddedComponents = Object.freeze({
    DOJO_WEBPOS_PAYMENT_METHOD_COMPONENT: 'DojoWebPosPaymentMethodComponent',

    GIFT_VOUCHER_PAYMENT_METHOD_COMPONENT: 'GiftVoucherPaymentMethodComponent',

    GOCARDLESS_PAYMENT_METHOD_COMPONENT: 'GoCardlessPaymentMethodComponent',

    MELLON_WEBECR_PAYMENT_METHOD_COMPONENT: 'MellonWebECRPaymentMethodComponent',

    ORDER_DETAILS_VIEW: 'OrderDetailsView',

    PAYMENT_METHOD_TABS: 'PaymentMethodTabs',

    PAYYO_PAYMENT_METHOD_COMPONENT: 'PayyoPaymentMethodComponent',

    SELL_VIEW: 'SellView',

    TAX_RECEIPT_TOGGLE: 'TaxReceiptToggle',

    TESCO_VOUCHER_UK_PAYMENT_METHOD_COMPONENT: 'TescoVoucherUkPaymentMethodComponent',
});

module.exports = EmbeddedComponents;
